<template>
  <div id="recContractChart"></div>
</template>

<script>
  import c3 from 'c3'

  export default {
    name: 'rec-contract-chart',
    props: {
      value: {
        type: Object,
        default: function () {
          return {}
        }
      }
    },
    methods: {
      init: function () {
        const vm = this
        const data = vm.value

        if (data) {
          // Chart Configuration
          const chartConfig = {
            bindto: '#recContractChart',
            padding: {
              right: 16
            },
            data: {
              x: 'x',
              columns: [
                ['x'].concat(data.rec_cont_land_period.map(x => x.slice(2, 4) + '/' + x.slice(4, 6))),
                ['육지'].concat(data.rec_cont_land_price),
                ['제주'].concat(data.rec_cont_jeju_price)
              ]
            },
            axis: {
              x: {
                type: 'category',
                label: {
                  text: '(년/월)',
                  position: 'inner-top'
                },
                tick: {
                  fit: true,
                  centered: true,
                  multiline: false,
                  format: function (d) {
                    return d % 2 === 0 ? data.rec_cont_land_period.map(x => '\'' + x.slice(2, 4) + '/' + x.slice(4, 6))[d] : ''
                  }
                }
              },
              y: {
                label: {
                  text: '(천원/SMP+REC)',
                  position: 'inner-top'
                },
                tick: {
                  format: function (d) {
                    return d / 1000
                  }
                }
              }
            },
            point: {
              show: false
            },
            line: {
              width: 2
            },
            legend: {
              // amount of padding to put between each legend element
              padding: 5,
              // define custom height and width for the legend item tile
              item: {
                tile: {
                  width: 15,
                  height: 2
                }
              }
            },
            grid: {
              y: {
                show: true
              }
            },
            color: {
              pattern: ['#00aeef', '#7a98b6']
            },
            tooltip: {
              format: {
                title: function (index) {
                  // YYYYMM => YY/MM 형태로 출력
                  const period = data.rec_cont_land_period[index]

                  return period.slice(2, 4) + '/' + period.slice(4, 6)
                },
                value: function (value) {
                  let price = '-'

                  // 3자리 콤마처리
                  if (value || typeof value !== 'undefined') {
                    const reg = /(^[+-]?\d+)(\d{3})/
                    let n = (value + '')

                    while (reg.test(n)) n = n.replace(reg, '$1' + ',' + '$2')

                    price = n + '원'
                  }

                  return price
                }
              }
            }
          }

          // Draw Chart
          c3.generate(chartConfig)
        }
      }
    },
    mounted: function () {
      this.init()
    }
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/chart/RecContractChart.vue